module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07493_logo_200x200.c967617a.png";